(() => {
  'use strict';
  if (window.UCWPrinterCatalog) return;
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const compare = (a, b) => a.localeCompare(b, 'nl', { numeric: true, sensitivity: 'base' });
  function createSource(collectionUrl, notify) {
    const items = new Map(), loaded = new Set(), requests = new Set();
    let total = 1, running = null, disposed = false, status = 'idle';
    const snapshot = () => ({ items: [...items.values()], loaded: loaded.size, total, status });
    const emit = () => { if (!disposed) notify(snapshot()); };
    async function batch(number) {
      if (loaded.has(number) || disposed) return;
      const url = new URL(collectionUrl, location.origin);
      if (url.origin !== location.origin) throw Error('Ongeldige collectie');
      url.searchParams.set('view', 'printerlijst-lazy'); url.searchParams.set('page', number);
      const controller = new AbortController(); requests.add(controller);
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw Error('Printerlijst niet beschikbaar');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (disposed) return;
        const payload = document.querySelector('[data-ucw-printer-payload]');
        if (!payload || Number(payload.dataset.batch) !== number) throw Error('Onvolledige printergegevens');
        const count = Number(payload.dataset.totalLinks), size = Number(payload.dataset.batchSize);
        const pages = Math.max(1, Math.ceil(count / size));
        if (!Number.isInteger(count) || count < 0 || !Number.isInteger(size) || size < 1 || !Number.isInteger(pages) || pages > 100 || number > pages) throw Error('Ongeldige paginering');
        if ((payload.dataset.hasMore === 'true') !== (number < pages)) throw Error('Onvolledige paginering');
        if (loaded.size && pages !== total) throw Error('De printerlijst is tussentijds gewijzigd');
        total = pages;
        payload.querySelectorAll('.printer-item[data-printer-url]').forEach(element => {
          const link = element.querySelector('a[href]');
          if (!link) return;
          const itemUrl = new URL(element.dataset.printerUrl, location.origin);
          if (itemUrl.origin !== location.origin || !/\/collections\/[^/]+\/?$/.test(itemUrl.pathname)) return;
          const group = element.closest('[data-printer-series]');
          const name = element.dataset.printerName || element.dataset.search || link.textContent.trim();
          const series = element.dataset.seriesName || group?.dataset.seriesName || '';
          const key = element.dataset.seriesKey || group?.dataset.printerSeries || 'overig';
          if (!name || items.has(itemUrl.pathname)) return;
          items.set(itemUrl.pathname, { name, series, key, productType: element.dataset.printerProductType || '', url: itemUrl.pathname, search: normalize(name), hpPlus: Boolean(element.querySelector('[data-hp-plus-popup-open]')), element });
        });
        loaded.add(number); emit();
      } finally { clearTimeout(timer); requests.delete(controller); }
    }
    function start() {
      if (running || disposed || status === 'complete') return running || Promise.resolve();
      status = 'loading'; emit();
      running = (async () => {
        try {
          if (!loaded.has(1)) await batch(1);
          let next = 2, failed = false;
          async function worker() {
            while (next <= total && !disposed) {
              const number = next++;
              try { await batch(number); } catch { failed = true; }
            }
          }
          await Promise.all(Array.from({ length: Math.min(4, total - 1) }, worker));
          status = !failed && loaded.size === total ? 'complete' : 'error';
        } catch { status = 'error'; }
        finally { running = null; emit(); }
      })();
      return running;
    }
    return { start, snapshot, dispose() { disposed = true; requests.forEach(request => request.abort()); items.clear(); } };
  }
  const sources = new Map();
  function create(collectionUrl, notify) {
    const url = new URL(collectionUrl, location.origin); url.hash = '';
    const key = url.href;
    let entry = sources.get(key);
    if (!entry) {
      entry = { subscribers: new Set(), source: null };
      entry.source = createSource(key, state => entry.subscribers.forEach(callback => callback(state)));
      sources.set(key, entry);
    }
    entry.subscribers.add(notify); notify(entry.source.snapshot());
    let disposed = false;
    return {
      start: () => disposed ? Promise.resolve() : entry.source.start(),
      snapshot: () => entry.source.snapshot(),
      dispose() {
        if (disposed) return; disposed = true;
        entry.subscribers.delete(notify);
        if (!entry.subscribers.size) { entry.source.dispose(); sources.delete(key); }
      }
    };
  }
  window.UCWPrinterCatalog = { create, normalize, compare };
})();
